import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";

import OuterLayout from "./components/Layout/OuterLayout";
import LoginForm from "./components/AuthManagement/LoginForm";
import ForgotPasswordForm from "./components/AuthManagement/ForgotPasswordForm";
import ResetPasswordForm from "./components/AuthManagement/ResetPasswordForm";
import SettingPasswordForm from "./components/AuthManagement/SettingPasswordForm";
import PlatformLayout from "./components/Layout/PlatformLayout";

import Admin from "./components/AdminDashboard/Admin";
import ServiceList from "./components/AdminDashboard/ServiceList";
// import CompanySystem from './components/AdminDashboard/CompanySystem';
import Workspace from "./components/AdminWorkspace/Workspace";
import Signed from "./components/AdminWorkspace/Signed";
import AIAgent from "./components/AdminWorkspace/AIAgent";
import EnterpriseList from "./components/ExecutiveDashboard/EnterpriseList";
import PersonalList from "./components/ExecutiveDashboard/PersonalList";
import Dashboard from "./components/ExecutiveDashboard/Business";
import Payment from "./components/ExecutiveDashboard/Payment";
import PlanManagement from "./components/ExecutiveDashboard/PlanManagement";
import LifeCycle from "./components/TdpDashboard/LifeCycle";
import TdpDashboard from "./components/TdpDashboard/Dashboard";
import QuestionPreview from "./components/TdpDashboard/QuestionPreview";
import PAEISettings from "./components/TdpDashboard/PAEISettings";
import RecommendCorse from "./components/TdpDashboard/PAEI/RecommendCorse";
import PersonalTalent from "./components/TdpDashboard/PersonalTalent";
import ASK from "./components/TdpDashboard/ASK/Lists";
import Blueprint from "./components/TdpDashboard/Blueprint/Lists";
import Category from "./components/TdpDashboard/Category/Lists";
import TdpDashboardOverview from "./components/TdpDashboard/DashboardOverview";
import Enterprise from "./components/TdpDashboard/Enterprise";
import Language from "./components/TdpDashboard/Language";
import EventList from "./components/EventManagement/EventList";
import EventFormPage from "./components/EventManagement/EventFormPage";
import RegistrationList from "./components/EventManagement/RegistrationList";
import EventHighlightsList from "./components/EventManagement/EventHighlightsList";
import EventHighlightFormPage from "./components/EventManagement/EventHighlightFormPage";
import ReleaseNotesList from "./components/AnnouncementManagement/ReleaseNotesList";
import ReleaseNoteFormPage from "./components/AnnouncementManagement/ReleaseNoteFormPage";
import SystemAnnouncementsList from "./components/AnnouncementManagement/SystemAnnouncementsList";
import SystemAnnouncementFormPage from "./components/AnnouncementManagement/SystemAnnouncementFormPage";
import AiLearningResourcesList from "./components/AiLearningResourcesManagement/AiLearningResourcesList";
import AiLearningResourceFormPage from "./components/AiLearningResourcesManagement/AiLearningResourceFormPage";
import RecommendedPromptsList from "./components/RecommendedPromptsManagement/RecommendedPromptsList";
import AiWaveLeadList from "./components/AiWaveLeadManagement/AiWaveLeadList";
import InvoicesList from "./components/FinanceManagement/InvoicesList";
import KeystoneAccountHome from "./components/KeystoneAccountHome/KeystoneAccountHome";
import ConsultationList from "./components/KeystoneManagement/ConsultationList";
import EnterprisePurchaseList from "./components/KeystoneManagement/EnterprisePurchaseList";
import PersonalSubscriptionList from "./components/KeystoneManagement/PersonalSubscriptionList";

import "react-loading-skeleton/dist/skeleton.css";

import {
  getAuth,
  selectPermissionSettings,
} from "./store/slice/permissionSettings";

const AuthManagement = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isRoot = () => {
    if (
      document.location.pathname.includes("/login") ||
      document.location.pathname.includes("/register") ||
      document.location.pathname.includes("/forgot-password") ||
      document.location.pathname.includes("/reset-password") ||
      document.location.pathname.includes("/confirm-email") ||
      document.location.pathname.includes("/setting-password")
    ) {
      return true;
    } else {
      return false;
    }
  };

  const serviceAreaElm = document.getElementById("service-area");
  if (!isRoot()) serviceAreaElm.style["display"] = "block";

  const { auth } = useSelector(selectPermissionSettings);
  const [cookies] = useCookies(["token"]);

  useEffect(() => {
    if (cookies.token) {
      dispatch(getAuth());
    } else if (!cookies.token && isRoot() === false) {
      navigate("/");
    }
  }, [cookies, dispatch, navigate]);

  return (
    <>
      <Routes>
        <Route element={<OuterLayout />}>
          <Route path='/' element={<LoginForm />} />
          <Route path='login' element={<LoginForm />} />
          <Route path='forgot-password' element={<ForgotPasswordForm />} />
          <Route path='reset-password' element={<ResetPasswordForm />} />
          <Route path='setting-password' element={<SettingPasswordForm />} />
        </Route>
      </Routes>

      {auth?.roles.find((item) => item === "workspace.admin") && (
        <Routes>
          <Route element={<PlatformLayout />}>
            <Route path='/admin/services' element={<ServiceList />} />
            <Route path='/admin/:id' element={<Admin />} />
            <Route path='/admin/company-system' element={<EnterpriseList />} />
            <Route path='/admin/workspace' element={<Workspace />} />
            <Route path='/personal-accounts/lists' element={<PersonalList />} />
          </Route>
        </Routes>
      )}

      {auth?.roles.find((item) => item === "workspace.user") && (
        <Routes>
          <Route element={<PlatformLayout />}>
            <Route path='/enterprise-list' element={<EnterpriseList />} />
            <Route path='/dashboard/business/:id' element={<Dashboard />} />
            <Route
              path='/dashboard/plan-management/:id'
              element={<PlanManagement />}
            />
            <Route path='/dashboard/payment/:id' element={<Payment />} />
            <Route path='/admin/workspace' element={<Workspace />} />
            <Route path='/personal-accounts' element={<PersonalList />} />
          </Route>
        </Routes>
      )}

      {/* ROLES : KEYSTONE */}
      <Routes>
        <Route element={<PlatformLayout />}>
          <Route path='/dashboard/tdp/home' element={<KeystoneAccountHome />} />
          <Route path='/dashboard/tdp/menu' element={<TdpDashboard />} />
          <Route
            path='/dashboard/tdp/menu/:id'
            element={<TdpDashboardOverview />}
          />
          <Route path='/dashboard/tdp/life-cycle' element={<LifeCycle />} />
          <Route
            path='/dashboard/tdp/life-cycle/question-preview'
            element={<QuestionPreview />}></Route>
          <Route
            path='/dashboard/tdp/PAEI-setting/:reference'
            element={<PAEISettings />}></Route>
          <Route
            path='/dashboard/tdp/PAEI-setting/recommend-corse'
            element={<RecommendCorse />}></Route>
          <Route
            path='/dashboard/tdp/personal-talent'
            element={<PersonalTalent />}></Route>
          <Route path='/dashboard/tdp/ask/:reference' element={<ASK />}></Route>
          <Route path='/dashboard/tdp/enterprise' element={<Enterprise />} />
          <Route path='/dashboard/tdp/events' element={<EventList />} />
          <Route
            path='/dashboard/tdp/events/registrations'
            element={<RegistrationList />}
          />
          <Route
            path='/dashboard/tdp/events/highlights'
            element={<EventHighlightsList />}
          />
          <Route
            path='/dashboard/tdp/events/highlights/new'
            element={<EventHighlightFormPage mode='new' />}
          />
          <Route
            path='/dashboard/tdp/events/highlights/:id/edit'
            element={<EventHighlightFormPage mode='edit' />}
          />
          <Route
            path='/dashboard/tdp/release-notes'
            element={<ReleaseNotesList />}
          />
          <Route
            path='/dashboard/tdp/release-notes/new'
            element={<ReleaseNoteFormPage mode='new' />}
          />
          <Route
            path='/dashboard/tdp/release-notes/:id/edit'
            element={<ReleaseNoteFormPage mode='edit' />}
          />
          <Route
            path='/dashboard/tdp/system-announcements'
            element={<SystemAnnouncementsList />}
          />
          <Route
            path='/dashboard/tdp/system-announcements/new'
            element={<SystemAnnouncementFormPage mode='new' />}
          />
          <Route
            path='/dashboard/tdp/system-announcements/:id/edit'
            element={<SystemAnnouncementFormPage mode='edit' />}
          />
          <Route
            path='/dashboard/tdp/ai-learning-resources'
            element={<AiLearningResourcesList />}
          />
          <Route
            path='/dashboard/tdp/ai-learning-resources/new'
            element={<AiLearningResourceFormPage mode='new' />}
          />
          <Route
            path='/dashboard/tdp/ai-learning-resources/:id/edit'
            element={<AiLearningResourceFormPage mode='edit' />}
          />
          <Route
            path='/dashboard/tdp/recommended-prompts'
            element={<RecommendedPromptsList />}
          />
          <Route
            path='/dashboard/tdp/ai-wave/leads'
            element={<AiWaveLeadList />}
          />
          <Route
            path='/dashboard/tdp/finance/invoices'
            element={<InvoicesList />}
          />
          <Route
            path='/dashboard/tdp/events/new'
            element={<EventFormPage mode='new' />}
          />
          <Route
            path='/dashboard/tdp/events/:id/edit'
            element={<EventFormPage mode='edit' />}
          />
          <Route
            path='/dashboard/tdp/category/:reference'
            element={<Category />}></Route>
          <Route
            path='/dashboard/tdp/blueprint/:reference'
            element={<Blueprint />}></Route>
          <Route path='/dashboard/tdp/language' element={<Language />} />
          <Route path='/admin/form/signed' element={<Signed />} />
          <Route path='/admin/form/ai-agent' element={<AIAgent />} />
          <Route
            path='/admin/keystone/consultations'
            element={<ConsultationList />}
          />
          <Route
            path='/admin/keystone/purchases'
            element={<EnterprisePurchaseList />}
          />
          <Route
            path='/admin/keystone/personal-subscriptions'
            element={<PersonalSubscriptionList />}
          />
        </Route>
      </Routes>
    </>
  );
};

export default AuthManagement;
